import { Box, Button, Group, LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useCompany } from '../Router/CompanyContent';
import { useDi } from '@root/Services/DI';
import { CompanyAdministrationPanelModel } from '../CompanyInfo/Administration/CompanyAdministrationPanelModel';
import { CompanyInfo } from '@apis/Customers/model';
import { CompanyContextService } from '@root/Services/Customers/CompanyContext';
import { AdminPageTitle, AdminPanel } from '../CompanyInfo/Administration/Design';
import { BillingInvoicesGrid } from './BillingInvoicesGrid';

export interface BillingInvoicesInfoProps {
    model: CompanyAdministrationPanelModel;
    companyInfo: CompanyInfo;
}

export const BillingInvoicesInfo = (props: BillingInvoicesInfoProps) => {
    return (
        <AdminPanel>
            <Box>
                <div style={{ height: '525px', overflow: 'auto' }}>
                    <BillingInvoicesGrid companyId={props.companyInfo.CompanyId} isAdminView={true}></BillingInvoicesGrid>
                </div>
            </Box>
        </AdminPanel>
    );
};
